import { render, staticRenderFns } from "./BulkTasks.vue?vue&type=template&id=4a450648&"
import script from "./BulkTasks.vue?vue&type=script&lang=js&"
export * from "./BulkTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports